module.exports = __webpack_public_path__ + "img/KinokoTable70.72d9930c.jpg";